import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Menu, Modal, Spin } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import WrapAction from '../../Inquiry/components/wrap-action';
import moment from 'moment';
import useDebounce from '@root/core/hooks/useDebounce';
import deliveryService from '@root/modules/Warehouse/Delivery/services/delivery';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { getDeliveryStatus } from '../helpers';
import DataPicker from '../../Inquiry/components/wrap-action/DataPicker';
import DropdownAction from '../../Shared/Actions/DropdownAction';

interface DataDelivery {
  id: React.Key;
  name: string;
  email: string;
  buyerName: string;
  orderNumber: string;
  status: string;
  updatedAt: string;
}

const DeliveryList = () => {
  /*------------state-----------------*/
  const [labelSelect, setLabelSelect] = useState({
    key: '1',
    label: 'Select'
  } as any);
  const [marketSelect, setMarketSelect] = useState({
    key: '',
    label: ''
  } as any);
  const [statusSelect, setStatusSelect] = useState({
    key: '',
    label: ''
  } as any);
  const [modalLabelSelect, setModalLabelSelect] = useState({
    key: '1',
    label: 'Select'
  } as any);
  const [modalMarketSelect, setModalMarketSelect] = useState({
    key: '',
    label: ''
  } as any);
  const [modalStatusSelect, setModalStatusSelect] = useState({
    key: '',
    label: ''
  } as any);

  const history = useHistory();
  const [listExcelDe, setListExcelDe] = useState([] as any);

  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [searchBy, setSearchBy] = useState('');
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [listData, setListData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filter, setFilter] = useState([] as any);
  const [filterDate, setFilterDate] = useState<[string, string]>();
  const [modalDate, setModalDate] = useState<[string, string]>();
  const fromDt: string = (filterDate && filterDate[0]) || '';
  const toDt: string = (filterDate && filterDate[1]) || '';
  const [sort, setSort] = useState(true);
  const [loading, setLoading] = useState(false);

  const [isSearch, setIsSearch] = useState('');

  /*-----------------------------*/

  const columns: ColumnsType<DataDelivery> = [
    {
      title: 'No',
      dataIndex: 'id'
      // render: (text, record, index) => index + 1
    },
    {
      title: 'Seller name',
      dataIndex: 'name'
    },
    {
      title: 'Seller E-mail Address',
      dataIndex: 'email'
    },
    {
      title: 'Buyer Name',
      dataIndex: 'buyerName'
    },
    {
      title: 'Order Number',
      dataIndex: 'orderNumber'
    },

    {
      title: 'Status',
      dataIndex: 'status'
    },

    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Update Date{' '}
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => {
                setSort(true);
                setPage(1);
              }}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => {
                setSort(false);
                setPage(1);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'updatedAt'
    }
  ];

  /*----------------------------checkbox---------------------*/
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataDelivery[]) => {
      setListExcelDe(selectedRows);
    },
    getCheckboxProps: (record: DataDelivery) => ({
      disabled: record.name === 'Disabled User',
      name: record.name
    })
  };

  /*----------------------excel---------------------------------*/

  const idMap = listExcelDe.map((item: any) => item.key);

  const arrId = {
    ids: idMap
  };

  const handleOnMessDown = async () => {
    console.log('download', listExcelDe);
    const filteredList = listExcelDe.map((item: any) => ({
      orderNumber: item.orderNumber,
      sellerId: item.data.sellerId
    }));
    console.log(filteredList, 'filteredList');
    if (filteredList.length > 0) {
      const response = await deliveryService.downloadMessInvoice(filteredList);
      console.log('response', response);
      const url = URL.createObjectURL(new Blob([response]));
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Mess_Delivery_` + utc + `.zip`;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  const handleOnExport = async () => {
    if (listExcelDe.length > 0) {
      const response = await deliveryService.postDownExcelDeliveryId(arrId);
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Delivery_` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await deliveryService.postDownExcelDelivery(
        fromDt,
        toDt,
        searchBy,
        valueSearch,
        sort,
        marketSelect.key,
        statusSelect.key
      );
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Delivery_` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  /*-------------------------------paging---------------------------------*/

  const [modalTotal, setModalTotal] = useState(0);
  //Handle pagination
  const getSelect = (e: any) => {
    setSearchBy(e.key);
    setLabelSelect({ key: e.key, label: e.domEvent.target.innerText });
  };

  const getMarket = (e: any) => {
    setMarketSelect({ key: e.key, label: e.domEvent.target.innerText });
  };
  const getStatus = (e: any) => {
    setStatusSelect({ key: e.key, label: e.domEvent.target.innerText });
  };
  const [modalData, setModalData] = useState([]);
  const [menuMarketData, setMenuMarketData] = useState({
    key: '',
    label: ''
  });
  const [menuStatusData, setMenuStatusData] = useState({
    key: '',
    label: ''
  });
  const getMenuMarket = (e: any) => {
    setMenuMarketData({ key: e.key, label: e.domEvent.target.innerText });
  };

  const getMenuStatus = (e: any) => {
    setMenuStatusData({ key: e.key, label: e.domEvent.target.innerText });
  };
  const menuMarket = [
    {
      id: 2,
      titleSelect: 'Market',
      list: (
        <Menu
          onClick={getMenuMarket}
          items={[
            {
              label: 'Amazon',
              key: 'Amazon'
            },
            {
              label: 'Ebay',
              key: 'Ebay'
            },
            {
              label: 'Rakuten',
              key: 'Rakuten'
            },
            {
              label: 'Qoo 10',
              key: 'Qoo10'
            },
            {
              label: 'Office Online Mall',
              key: 'OfficeOnlineMall'
            },
            {
              label: 'Shopee',
              key: 'Shopee'
            },
            {
              label: 'Others',
              key: 'Others'
            }
          ]}
        />
      )
    }
  ];
  const menuStatus = [
    {
      id: 3,
      titleSelect: 'Status',
      list: (
        <Menu
          onClick={getMenuStatus}
          items={[
            {
              label: 'Request',
              key: 'Request'
            },
            {
              label: 'In Delivery',
              key: 'InDelivery'
            },
            {
              label: 'Delivered',
              key: 'Delivered'
            }
          ]}
        />
      )
    }
  ];

  const modalFetch = async () => {
    if (!!!modalDate?.[0] || !!!modalDate?.[1]) return;
    const from: string = (modalDate && modalDate[0]) || '';
    const to: string = (modalDate && modalDate[1]) || '';
    console.log(
      from,
      to,
      modalMarketSelect.key,
      modalStatusSelect.key,
      'HIHIHI'
    );
    const res = await deliveryService.getDeliveryModal(
      from,
      to,
      menuMarketData.key,
      menuStatusData.key
    );

    setModalTotal(res.count);
    const rowData = res.data?.map((row: any) => {
      return {
        ...row,
        key: row.id,
        updatedAt: formatDateTime(row.updatedAt),
        status: getDeliveryStatus(row.status)
      };
    });

    setModalData(rowData);
  };

  useEffect(() => {
    modalFetch();
  }, [modalDate, menuMarketData, menuStatusData]);
  const handelPagination = async (
    page: number,
    fromDt?: string,
    toDt?: string,
    searchBy?: string,
    filterInput?: string,
    sort?: boolean,
    market?: string,
    status?: string
  ) => {
    setLoading(true);

    const res = await deliveryService.getPagingDelivery(
      page,
      fromDt,
      toDt,
      searchBy,
      filter,
      filterInput,
      sort,
      market,
      status
    );
    setTotalPages(res.count);
    const rowData = res.data?.map((row: any) => {
      return {
        ...row,
        key: row.id,
        updatedAt: formatDateTime(row.updatedAt),
        status: getDeliveryStatus(row.status)
      };
    });

    setListData(rowData);
    setLoading(false);
  };

  useEffect(() => {
    if (!!valueSearch && !!setSearchBy) setIsSearch(valueSearch);
    else if (!!isSearch && !valueSearch) {
      setIsSearch('');
      setPage(1);
    }
  }, [debounc, setSearchBy]);

  useEffect(() => {
    handelPagination(
      1,
      fromDt,
      toDt,
      searchBy,
      valueSearch,
      sort,
      marketSelect.key,
      statusSelect.key
    );
    setPage(1);

    // }, [page, searchBy, debounc, fromDt, toDt, sort]);
  }, [isSearch, fromDt, toDt, sort, searchBy, marketSelect, statusSelect]);

  console.log(menuMarket, menuStatus);
  const onChangeSearch = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDateValue = (value: [string, string]) => {
    setFilterDate(value);
    setPage(1);
  };

  const handleUpload = () => {
    history.push('/admin/delivery/csv');
  };

  return (
    <Spin spinning={loading}>
      <WrapAction
        getSelect={getSelect}
        getMarket={getMarket}
        getStatus={getStatus}
        labelSelect={labelSelect}
        typeDrop="delivery"
        market={marketSelect}
        status={statusSelect}
        onChangeSearch={onChangeSearch}
        getDateValue={getDateValue}
        warehouseUploadCsvButton={true}
        warehouseUploadCsvButtonClick={() => handleUpload()}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '15px 17px',
          background: 'white',
          alignItems: 'center'
        }}
      >
        <div>
          <span style={{ marginLeft: '8px', marginRight: '8px' }}>
            Total Delivery {totalPages}
          </span>
          <div
            className="ant-divider ant-divider-vertical"
            role="separator"
          ></div>
          {listExcelDe.length !== 0 ? (
            <span style={{ marginLeft: '8px', marginRight: '8px' }}>
              Select Delivery {listExcelDe?.length}
            </span>
          ) : (
            <span style={{ marginLeft: '8px', marginRight: '8px' }}>
              Select Seller 00
            </span>
          )}
        </div>

        <div style={{ display: 'flex' }}>
          <Button
            style={{
              marginRight: '8px'
            }}
            className="downExcel"
            // onClick={handleOnMessDown}
            onClick={() => {
              setIsModalOpen(true);
              modalFetch();
            }}
          >
            Mess Shipping Label Download
          </Button>
          <Button
            className="downExcel"
            onClick={() => {
              handleOnExport();
            }}
          >
            Download Excel
          </Button>
        </div>
      </div>
      <Modal
        footer={
          <div
            style={{ display: 'flex', justifyContent: 'end', width: '100%' }}
          >
            <Button
              onClick={handleOnMessDown}
              style={{ borderRadius: 8, width: 120 }}
              className="btn-disabled"
            >
              Download
            </Button>
          </div>
        }
        closeIcon={<div onClick={() => setIsModalOpen(false)}>X</div>}
        title="Mess Shipping Label Download"
        className="cm"
        style={{ height: '80%', minWidth: 1200 }}
        visible={isModalOpen}
        // width={'90%'}
      >
        <div style={{ width: 1200, display: 'flex', gap: 5 }}>
          <DataPicker getDate={setModalDate} />
          {menuMarket.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={
                  menuMarketData?.label ? menuMarketData?.label : 'Market'
                }
                list={item.list}
              />
            );
          })}
          {menuStatus.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={
                  menuStatusData?.label ? menuStatusData?.label : 'Status'
                }
                list={item.list}
              />
            );
          })}
        </div>
        <div
          style={{
            width: '100%',
            marginTop: 16,
            display: 'flex',
            justifyContent: 'space-between',
            padding: '15px 17px',
            background: 'white',
            alignItems: 'center'
          }}
        >
          <div style={{ width: '100%' }}>
            <span style={{ marginLeft: '8px', marginRight: '8px' }}>
              Total Delivery {modalTotal}
            </span>
            <div
              className="ant-divider ant-divider-vertical"
              role="separator"
            ></div>

            <span style={{ marginLeft: '8px', marginRight: '8px' }}>
              Select Delivery {modalData?.length}
            </span>
          </div>
        </div>
        {modalData.length ? (
          <Table
            scroll={{ y: 55 * 8 }}
            style={{ width: '100%' }}
            className="warehouse-table"
            pagination={false}
            // rowSelection={rowSelectionn}
            // dataSource={dataSource}
            // columns={columns}
            // onRow={(item) => {
            //   return {
            //     onClick: () => {
            //       history.push(`/admin/detail-delivery/${item.key}`);
            //     }
            //   };
            // }}
            columns={columns}
            dataSource={modalData}
            rowSelection={rowSelection}
          />
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
              fontSize: 16,
              color: '#838383'
            }}
          >
            <span>
              Please apply the filters downloading the desired invoice
            </span>
          </div>
        )}
      </Modal>

      <Table
        className="warehouse-table"
        // rowSelection={rowSelectionn}
        // dataSource={dataSource}
        // columns={columns}
        // onRow={(item) => {
        //   return {
        //     onClick: () => {
        //       history.push(`/admin/detail-delivery/${item.key}`);
        //     }
        //   };
        // }}
        columns={columns}
        dataSource={listData}
        rowSelection={rowSelection}
        pagination={{
          total: totalPages,
          current: page,
          showSizeChanger: false,

          onChange: (page, limit) => {
            setPage(page);

            handelPagination(
              page,
              fromDt,
              toDt,
              searchBy,
              valueSearch,
              sort,
              marketSelect.key,
              statusSelect.key
            );
          }
        }}
        onRow={(item) => {
          return {
            onClick: () => {
              history.push(`/admin/delivery/${item.id}`);
              // history.push(`/admin/inquiry/${item.id}`);
            }
          };
        }}
      />
    </Spin>
  );
};

export default DeliveryList;
